import React from 'react';
import { testimonials } from '../../data/site';
export function Testimonial() {
  const featured = testimonials[0];
  return <section className="bg-cream-deep" data-id="element-111" data-mp="2kuwuvq91qu3l">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-112" data-mp="2kvy4dqaez8j7">
        <blockquote className="mx-auto max-w-4xl text-center" data-id="element-113" data-mp="2672269v1gpqi">
          <p className="font-serif text-3xl leading-[1.2] text-ink md:text-[2.75rem]" data-id="element-114" data-mp="2b3jzwprybntc">
            “{featured.quote}”
          </p>
          <footer className="rule mx-auto mt-10 inline-block pt-5 text-sm text-ink-muted" data-id="element-115" data-mp="2yuphpahgcq6a">
            <span className="text-ink" data-id="element-116" data-mp="33shae6px8gbj">{featured.name}</span> · {featured.detail}
          </footer>
        </blockquote>
      </div>
    </section>;
}